module.exports = __webpack_public_path__ + "media/images/athletes/2193-f92d334977e515845c0d162cbfbfc6d3.png";